import { useTranslation } from 'react-i18next';
import { EntraGroup } from '@sib/api';
import { useUserSetupStore } from '@sib/auth';
import { Button } from '@sib/ui';
import { SwitchIcon } from '@spendbrain/icons/SwitchIcon';
import { useDialog } from '../hooks';
import { OrganizationSwitchDialog } from './OrganizationSwitchDialog';

interface OrganizationSwitchProps {
  className?: string;
}

export const OrganizationSwitch = (props: OrganizationSwitchProps) => {
  const { isOpen, handleOpen, handleClose } = useDialog();
  const { userRoles } = useUserSetupStore();
  const { t } = useTranslation();

  const isUserAllowedToSwitchOrganization =
    userRoles.includes(EntraGroup.ClientResultManager) ||
    userRoles.includes(EntraGroup.Employee);

  return isUserAllowedToSwitchOrganization ? (
    <>
      <Button onClick={handleOpen} variant="outline" {...props}>
        <SwitchIcon className="text-primary h-5 w-5" />
        <span className="hidden sm:block">
          {t('components.organizationSwitch.title')}
        </span>
      </Button>
      <OrganizationSwitchDialog open={isOpen} onClose={handleClose} />
    </>
  ) : null;
};
